<template>
  <header class="page-navigation">
    <div class="page-title">
      <h2 v-html="title" :key="title" />
      <slot name="subtitle"/>
    </div>
    <slot name="right"/>
  </header>
</template>

<script>
export default {

  props: {
    title: {
      type: String,
      default: ''
    }
  },

}
</script>
